<template>
  <router-view />
</template>

<script>
import 'vuetify/dist/vuetify.min.css';

export default {};
</script>

<style>
body {
  min-width: 1360px; /* TODO: lock to desktop view */
}
</style>
